import { translateInline } from '@/globals/translate/translateInline';

export const sharesheetButtonTranslations = {
	Share: translateInline({
		en: 'Share',
		nl: 'Delen',
	}),
	'Share results': translateInline({
		en: 'Share results',
		nl: 'Deel resultaten',
	}),
	'Share this page': translateInline({
		en: 'Share this page',
		nl: 'Deze pagina delen',
	}),
} as const;

export const sharesheetStatusTranslations = {
	'Link copied': translateInline({
		en: 'Link copied',
		nl: 'Link gekopieerd',
	}),
	'Cannot copy link': translateInline({
		en: 'Cannot copy link',
		nl: 'Kan link niet kopiëren',
	}),
	'Cannot open share options': translateInline({
		en: 'Cannot open share options',
		nl: 'Kan deelopties niet openen',
	}),
	'We’re trying to open your email program': translateInline({
		en: 'We’re trying to open your email program',
		nl: 'We proberen je e-mailprogramma te openen',
	}),
} as const;
